import { DEFAULT_GRADIENT_STOPS } from "../lib/colorScale";
import { useLanguage } from "../i18n/LanguageContext";

/** Continuous gradient legend bar with "Fewer clicks" / "More clicks" labels. */
export function MapLegend() {
  const { t } = useLanguage();
  const gradientCss = `linear-gradient(90deg, ${DEFAULT_GRADIENT_STOPS.join(", ")})`;

  return (
    <div className="flex items-center gap-3 text-xs text-slate-600">
      <span className="whitespace-nowrap">{t("legend.fewer")}</span>
      <div
        className="h-3 flex-1 rounded-full border border-slate-300"
        style={{ background: gradientCss }}
        aria-hidden="true"
      />
      <span className="whitespace-nowrap">{t("legend.more")}</span>
    </div>
  );
}
